export const navLinks = [
  {
    name: "Shop",
    hideSm: false,
    link: "/shop",
    links: [
      {
        contName: "Categories",
        contLink: "/shop",
      },
      {
        contName: "Sale",
        contLink: "/shop",
      },
      {
        contName: "Collections",
        contLink: "/shop",
      },
      {
        contName: "Brands",
        contLink: "/shop",
      },
    ],
  },

  {
    name: "New Arrival",
    hideSm: false,
    link: "/new-arrivals",
    links: [
      {
        contName: "Today",
        contLink: "/new-arrivals",
      },
      {
        contName: "This Week",
        contLink: "/new-arrivals",
      },
      {
        contName: "This Month",
        contLink: "/new-arrivals",
      },
      {
        contName: "This Season",
        contLink: "/new-arrivals",
      },
    ],
  },
  {
    name: "Top Sellers",
    hideSm: false,
    link: "/best-sellers",
    links: [
      {
        contName: "This Week",
        contLink: "/best-sellers",
      },
      {
        contName: "This Month",
        contLink: "/best-sellers",
      },
      {
        contName: "This Year",
        contLink: "/best-sellers",
      },
    ],
  },
  {
    name: "Branches",
    hideSm: false,
    link: "/about",
    links: [
      {
        contName: "United States",
        contLink: "/about",
      },
      {
        contName: "United Kingdom",
        contLink: "/about",
      },
      {
        contName: "Egypt",
        contLink: "/about",
      },
      {
        contName: "United Arab Emirates",
        contLink: "/about",
      },
    ],
  },
  {
    name: "About",
    hideSm: false,
    link: "/about",
    links: [
      {
        contName: "Our Stores",
        contLink: "/about",
      },
      {
        contName: "Our History",
        contLink: "/about",
      },
      {
        contName: "Contact Us",
        contLink: "/about",
      },
      {
        contName: "Headquarter",
        contLink: "/about",
      },
    ],
  },
];

export const sliderSlides = [
  {
    id: "0",
    img: "./assets/hero-slider/hero-01.jpg",
    firstText: "Just arrived !",
    secondText: "Winter Collection",
    thirdText: "Don't miss it",
  },
  {
    id: "1",
    img: "./assets/hero-slider/hero-02.jpg",
    firstText: "Complete your look with",
    secondText: "Our shoes",
    thirdText: "Collection",
  },
  {
    id: "2",
    img: "./assets/hero-slider/hero-03.jpg",
    firstText: "Hurry up!",
    secondText: "Winter Sale",
    thirdText: "Is now happening now",
  },
];

export const featuredCards = [
  {
    id: "1",
    image: "./assets/hero-slider/casual.png",
    firstText: "School",
    secondText: "Casual",
    thirdText: "Collection",
  },
  {
    id: "2",
    image: "./assets/hero-slider/classic.png",
    firstText: "Formal",
    secondText: "Classic",
    thirdText: "Suits",
  },
  {
    id: "3",
    image: "./assets/hero-slider/sport.png",
    firstText: "Trendy",
    secondText: "Sportive",
    thirdText: "Fashion",
  },
];

export const navDepartments = [
  {
    title: "Shoes",
    image: "./assets/nav-categories/cat-img-shoes.jpg",
    content: [
      {
        name: "New Collection",
        link: "Shoes",
      },
      {
        name: "Sport shoes",
        link: "Shoes",
      },
      {
        name: "Sneakers collection",
        link: "Shoes",
      },
    ],
  },
  {
    title: "Jackets",
    image: "./assets/nav-categories/cat-img-jackets.jpg",
    content: [
      {
        name: "Casual jackets",
        link: "Jackets",
      },
      {
        name: "Jeans jackets",
        link: "Jackets",
      },
      {
        name: "Fashion picks",
        link: "Jackets",
      },
    ],
  },
  {
    title: "T-shirts",
    image: "./assets/nav-categories/cat-img-t-shirts.jpg",
    content: [
      {
        name: "Polo T-shirts",
        link: "Tshirts",
      },
      {
        name: "V cut T-shirts",
        link: "Tshirts",
      },
      {
        name: "Rounded nick",
        link: "Tshirts",
      },
    ],
  },
  {
    title: "Pants",
    image: "./assets/nav-categories/cat-img-pants.jpg",
    content: [
      {
        name: "Sport pants",
        link: "Pants",
      },
      {
        name: "Jeans pants",
        link: "Pants",
      },
      {
        name: "Classic Style",
        link: "Pants",
      },
    ],
  },
  {
    title: "Hoodies",
    image: "./assets/nav-categories/cat-img-hoodies.jpg",
    content: [
      {
        name: "Zipper Hoodies",
        link: "Hoodies",
      },
      {
        name: "Big hooded hoodies",
        link: "Hoodies",
      },
      {
        name: "Winter collection",
        link: "Hoodies",
      },
    ],
  },
  {
    title: "Suits",
    image: "./assets/nav-categories/cat-img-suits.jpg",
    content: [
      {
        name: "For wedding",
        link: "Suits",
      },
      {
        name: "For work",
        link: "Suits",
      },
      {
        name: "For every day",
        link: "Suits",
      },
    ],
  },
];

export const shopDepartments = [
  { title: "Shoes", link: "/shop/Shoes" },
  { title: "Jackets", link: "/shop/Jackets" },
  { title: "T-Shirts", link: "/shop/Tshirts" },
  { title: "Pants", link: "/shop/Pants" },
  { title: "Hoodies", link: "/shop/Hoodies" },
  { title: "Suits", link: "/shop/Suits" },
];

export const accountLinks = [
  { title: "Your account", link: "/about" },
  { title: "Shipping rates & policies", link: "/about" },
  { title: "Refund & replacements", link: "/about" },
  { title: "Order tracking", link: "/about" },
  { title: "delivery info", link: "/about" },
  { title: "Taxes & fees", link: "/about" },
];

export const aboutLinks = [
  { title: "About company", link: "/about" },
  { title: "Our team", link: "/about" },
  { title: "Careers", link: "/about" },
  { title: "News", link: "/about" },
];

export const shopCategories = [
  {
    id: 1,
    title: "Shoes",
    image: "../../../assets/shop/shop-shoes.jpg",
    link: "#",
  },
  {
    id: 2,
    title: "Tshirts",
    image: "../../../assets/shop/shop-tshirts.jpg",
    link: "#",
  },
  {
    id: 3,
    title: "Hoodies",
    image: "../../../assets/shop/shop-hoodies.jpg",
    link: "#",
  },
  {
    id: 4,
    title: "Jackets",
    image: "../../../assets/shop/shop-jackets.jpg",
    link: "#",
  },
  {
    id: 5,
    title: "Pants",
    image: "../../../assets/shop/shop-pants.jpg",
    link: "#",
  },
  {
    id: 6,
    title: "Suits",
    image: "../../../assets/shop/shop-suits.jpg",
    link: "#",
  },
];

export const langs = [
  {
    title: "ReactJs",
    image: "../../assets/langs/reactjs.png",
  },
  {
    title: "Redux",
    image: "../../assets/langs/redux.png",
  },
  {
    title: "TailwindCSS",
    image: "../../assets/langs/tailwind.png",
  },
  {
    title: "NodeJs",
    image: "../../assets/langs/nodejs.png",
  },
  {
    title: "Mongodb",
    image: "../../assets/langs/mongodb.png",
  },
  {
    title: "ExpressJs",
    image: "../../assets/langs/expressjs.png",
  },
];
